import React, {
  useRef, useEffect, useState, useMemo,
} from 'react';
import { useSelector } from 'react-redux';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { selectActiveMQ } from 'core/modules/MediaQueries/selectors';
import { useCheckSectionIsScrolled, useCheckIsSticky, useCalculateStickyHeaderHeight } from './hooks';
import { StickyContext } from './context/StickyContext';

import './StickyMenu.scss';

function StickyMenu({
  children, bottomOffset, wrapperRef, shouldUseSticky = true, shouldShowNonStickyMenu = true,
}) {
  const [isHeightReset, setIsHeightReset] = useState(false);
  const [stickyMenuHeight, setStickyMenuHeight] = useState(0);
  const stickyMenuRef = useRef();
  const activeMQ = useSelector(selectActiveMQ);
  const stickyHeaderHeight = useCalculateStickyHeaderHeight();
  const isSectionScrolled = useCheckSectionIsScrolled(wrapperRef, stickyHeaderHeight, bottomOffset);
  const isSticky = useCheckIsSticky(stickyMenuRef, stickyHeaderHeight, isSectionScrolled, isHeightReset);
  const stickyClassName = isSticky ? 'mn_stickyMenu' : '';

  useEffect(() => {
    setStickyMenuHeight(0);
    setIsHeightReset(true);
  }, [activeMQ]);

  useEffect(() => {
    if (isHeightReset && !isSticky) {
      setStickyMenuHeight(stickyMenuRef?.current?.offsetHeight || 0);
      setIsHeightReset(false);
    }
  }, [isHeightReset, isSticky]);

  const providerValue = useMemo(() => ({
    isSticky, stickyClassName, stickyHeaderHeight, stickyMenuRef,
  }), [isHeightReset, isSticky, activeMQ]);

  if (!shouldUseSticky) {
    return children;
  }

  if (!shouldShowNonStickyMenu) {
    return (
      <StickyContext.Provider value={providerValue}>
        { isSticky ? children : null }
      </StickyContext.Provider>
    );
  }

  return (
    <StickyContext.Provider value={providerValue}>
      <div className="mn_stickyMenuWrapper" ref={stickyMenuRef} style={{ minHeight: `${stickyMenuHeight}px` }}>
        {children}
      </div>
    </StickyContext.Provider>
  );
}

export default (props) => <ComponentErrorBoundary><StickyMenu {...props} /></ComponentErrorBoundary>;
